import styled from 'styled-components'

export const Line = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0.5rem 1.8rem;
  background: ${({ theme }) => theme.colors.modalBackground};
`

export const Button = styled.button`
  color: ${({ theme }) => theme.colors.hover};
  border: none;
  background: none;
  cursor: pointer;
  display: inline-flex;
  padding: 1rem;
  justify-self: end;
`
